import type { SVGProps } from 'react';

const WarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.257 3.1c.765-1.36 2.721-1.36 3.486 0l6.518 11.59c.75 1.333-.214 2.98-1.743 2.98H3.482c-1.53 0-2.493-1.647-1.743-2.98L8.257 3.1ZM10 7a.9.9 0 0 1 .9.9v3.2a.9.9 0 1 1-1.8 0V7.9A.9.9 0 0 1 10 7Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      fill="currentColor"
    />
  </svg>
);

export default WarningIcon;
